// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg[data-v-3b5dbdbb] {\n  max-width: 100%;\n}\n.footer1[data-v-3b5dbdbb] {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Garante que o conteúdo ocupe pelo menos 100% da altura da tela */\n}\n\n", ""]);
// Exports
module.exports = exports;
